import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { message } from 'ant-design-vue';
import { queryWareCategory } from '@/api/ware/category';
import EditableCell from '@/component/editable-cell.vue';
import SingleImageUpload from '@/component/single-image-upload.vue';
import {
  getHomeCategoryList,
  HomeCategoryData,
  initHomeCategory,
  saveHomeCategory,
} from '@/api/operation/home_category';

export default /*#__PURE__*/_defineComponent({
  __name: 'home-category',
  setup(__props) {

const uuidv4 = require('uuid/v4');
const form = ref<any>({ category_id: 2 });
const is_loading = ref<boolean>(false);
const table_data = ref<HomeCategoryData[]>(initHomeCategory());
const category_list = ref<any>([]);
const is_first = ref<boolean>(false);
const preview_image = ref<string>('');
const preview_visible = ref<boolean>(false);

// 显示模态窗，改变模态窗中的图片路径
function handlePreview(imageUrl: string) {
  preview_image.value = imageUrl;
  preview_visible.value = true;
}

// 排序值
function handleSortChange(index: number, sort: number) {
  if (!/^[0-9]+$/.test(sort + '')) {
    message.error('排序值须为>0的整数值！');
    return;
  }
  if (!(table_data.value[index] as any).is_new) {
    (table_data.value[index] as any).is_edit = true;
    (table_data.value[index] as any).sort = sort;
  } else {
    (table_data.value[index] as any).sort = sort;
  }
}
// 分类角标
function handleInputChange(index: number, corner_mark: string) {
  if (!(table_data.value[index] as any).is_new) {
    (table_data.value[index] as any).is_edit = true;
    (table_data.value[index] as any).corner_mark = corner_mark;
  } else {
    (table_data.value[index] as any).corner_mark = corner_mark;
  }
  console.log(table_data.value);
}
// 图片
function beforeCommonUpload(index: number) {
  if (!(table_data.value[index] as any).is_new) {
    (table_data.value[index] as any).is_edit = true;
  }
}
onMounted(async () => {
  // 获取跳转分类
  const res = await queryWareCategory();
  category_list.value = res;
  category_list.value.unshift({
    id: '0',
    name: '全部',
  });

  // 获取首页分类
  const result = await getHomeCategoryList();
  is_loading.value = true;
  table_data.value = initHomeCategory();
  if (result.status !== 200) {
    message.error((result as any).message);
    is_loading.value = false;
    return;
  }
  table_data.value = initHomeCategory(result.data);
  is_first.value = !result.data.length;
  table_data.value.forEach((item: any) => {
    item.is_edit = false;
    item.table_id = uuidv4();
    item.product_category_id =
      item.product_category_id === -1 ? undefined : item.product_category_id;
    item.product_category_id = item.product_category_id === 0 ? '0' : item.product_category_id;
  });
  for (let i = table_data.value.length; i < 10; i++) {
    table_data.value.push({
      sort: i + 1,
      image_url: '',
      product_category_id: '',
      is_new: true,
      table_id: uuidv4(),
    } as any);
  }
  is_loading.value = false;
});
// 保存
async function clickSaveBtn() {
  is_loading.value = true;
  const add_product: any = [];
  const edit_product: any = [];
  for (let i = 0; i < table_data.value.length; i++) {
    if (
      (table_data.value[i].image_url && !table_data.value[i].product_category_id) ||
      (!table_data.value[i].image_url && table_data.value[i].product_category_id)
    ) {
      message.error('请确认图片和跳转分类均已填写');
      is_loading.value = false;
      return;
    }
  }
  if (is_first.value) {
    table_data.value.forEach((item: any) => {
      add_product.push({
        sort: item.sort,
        image_url:
          item.image_url.indexOf('https') === -1 && item.image_url
            ? `https:${item.image_url}`
            : item.image_url,
        product_category_id: item.product_category_id ? item.product_category_id : -1,
        id: item.id,
        corner_mark: item.corner_mark,
      });
    });
  } else {
    table_data.value.forEach((item: any) => {
      edit_product.push({
        sort: item.sort,
        image_url:
          item.image_url.indexOf('https') === -1 && item.image_url
            ? `https:${item.image_url}`
            : item.image_url,
        product_category_id: item.product_category_id ? item.product_category_id : -1,
        id: item.id,
        corner_mark: item.corner_mark,
      });
    });
  }
  const res = await saveHomeCategory({ add: add_product, edit: edit_product });
  if (res.status !== 200) {
    message.error((res as any).message);
    is_loading.value = false;
    return;
  }
  is_loading.value = false;
  message.success('保存成功');
  getHomeCategoryList();
}

return { __sfc: true,uuidv4, form, is_loading, table_data, category_list, is_first, preview_image, preview_visible, handlePreview, handleSortChange, handleInputChange, beforeCommonUpload, clickSaveBtn, EditableCell, SingleImageUpload }
}

})